<template>
  <b-overlay :show="loading" class="row bg-white">
    <div class="col-12 mt-3">
      ¿Estás seguro de que quieres rechazar el Lote Nº {{ batch.folio }}?
    </div>
    <div class="col-12 mt-3">
      <b-form id="form-message" data-vv-scope="form-message">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Motivo por el que se rechaza el lote"
              label-for="#"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="HelpCircleIcon"/>
                </b-input-group-prepend>
                <b-form-input
                  placeholder="Rechazado por no...."
                  v-model="cause"
                  v-validate="'required|min:6'"
                  data-cy="cause"
                  data-vv-as="Motivo"
                  id="cause"
                  name="cause"
                  :state="errors.has('form-message.cause') ? false : null"
                />

                <b-form-invalid-feedback>
                  {{ errors.first('form-message.cause') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <vs-divider></vs-divider>
    <b-col
      cols="12"
      class="text-right"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        v-on:click="onReject"
        data-cy="cancel-batch"
      >
        Si, Estoy seguro!
      </b-button>
    </b-col>
  </b-overlay>
</template>
<script>

import { rejectBatch } from '@/febos/servicios/api/aduanas/batches.api';

export default {
  data() {
    return {
      loading: false,
      cause: ''
    };
  },
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  methods: {
    async onReject() {
      const isValid = await this.$validator.validateAll('form-message');
      if (!isValid) {
        return;
      }
      this.loading = true;
      try {
        await rejectBatch({
          loteId: this.batch.loteId,
          message: this.cause
        });
        this.$emit('cancel');
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    this.loading = false;
    this.cause = '';
  }
};
</script>
